import React, { useContext } from 'react';
import { FlowContext } from '../../core/flow-engine';
import methodologyLanguage from './methodology-language.json';
import { renderModalContent } from './util';
import { modalCloseNextModalHandler } from '../Modal/utils';
import closeBtn from '../../assets/images/Icon-button-close-beacon.svg';

import styles from './style.css';
import { MFBeaconIconButton, MFBeaconModal } from '../Beacon/BeaconComponents';

const SFMethodologyModal = () => {
  const { closeNextModal } = useContext(FlowContext);
  const { modalTitle, mainDesc, content } = methodologyLanguage;

  return (
    <>
      <MFBeaconModal scale="jumbo" removeCloseButton id="sfMethodologyModal">
        <span className="modal-close-icon">
          <MFBeaconIconButton
            id="selectFundsModalCloseIcon"
            variant="tertiary"
            onClick={() => modalCloseNextModalHandler(closeNextModal)}
            label="close-button">
            <img slot="icon" src={closeBtn} alt="close icon" />
          </MFBeaconIconButton>
        </span>
        <div className="beacon-modal__title">{modalTitle}</div>
        <div className="beacon-modal__description">
          <p>{mainDesc}</p>
        </div>
        <span className="modal-content">
          {renderModalContent(content, styles)}
        </span>
      </MFBeaconModal>
      <style jsx>{styles}</style>
    </>
  );
};

export default SFMethodologyModal;
